import React from "react";
import { formatNewsPublishDate } from "./news";

import "./NewsDetailHeader.less";

/** 各端共用文章信息；后台预览使用创建日期，公开详情使用发布日期。 */
export default function NewsDetailHeader({ article, previewMode = false }) {
  if (!article) return null;

  const title = String(article.title || "").trim();
  const author = String(article.author || "").trim();
  const categoryLabel = String(article.categoryLabel || "").trim();
  const publishDate = formatNewsPublishDate(
    previewMode ? article.tmCreate : article.tmPublished
  );
  const publication = [publishDate, categoryLabel].filter(Boolean).join("·");
  const meta = [author, publication].filter(Boolean).join(" ");

  return (
    <header className="news-detail-header">
      {title ? (
        <h1 className="news-detail-header__title" title={title}>{title}</h1>
      ) : null}
      {meta ? (
        <div className="news-detail-header__meta" title={meta}>
          {author ? (
            <span className="news-detail-header__author">{author}</span>
          ) : null}
          {publication ? (
            <span className="news-detail-header__publication">
              {publishDate ? (
                <time className="news-detail-header__date" dateTime={publishDate}>
                  {publishDate}
                </time>
              ) : null}
              {publishDate && categoryLabel ? <span aria-hidden="true">·</span> : null}
              {categoryLabel ? (
                <span className="news-detail-header__category">{categoryLabel}</span>
              ) : null}
            </span>
          ) : null}
        </div>
      ) : null}
    </header>
  );
}
